import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import api from '../api/axios';

/* ══════════════════════════════════════════════════════════════
   SITE CONFIG

   Which JLPT levels are live, and which pages are open. Both were
   hardcoded in the frontend and needed a redeploy to change; they are
   operational decisions, so the admin panel owns them now.

   Fetched once at app start. If the request fails we assume everything
   is open rather than locking the learner out of a working app because
   one auxiliary endpoint hiccupped.
══════════════════════════════════════════════════════════════ */

const FALLBACK = {
  levels: { N5: true, N4: false, N3: false, N2: false, N1: false },
  pages: {},
};

const ConfigContext = createContext({ config: FALLBACK, ready: false });

export const useAppConfig = () => useContext(ConfigContext);

/* Convenience for the common question. Unknown page = open. */
export function usePageState(pageKey) {
  const { config } = useAppConfig();
  const page = config.pages?.[pageKey];
  return {
    enabled: page ? page.enabled !== false : true,
    message: page?.message || '',
    label: page?.label || '',
  };
}

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(FALLBACK);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get('/config')
      .then(res => { if (alive && res.data?.data) setConfig(res.data.data); })
      .catch(() => {})
      .finally(() => { if (alive) setReady(true); });
    return () => { alive = false; };
  }, []);

  const value = useMemo(() => ({ config, ready }), [config, ready]);
  return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
}
